/**
 * Labstep
 *
 * @module core/DataGrid/Placeholder
 * @desc DataGrid Placeholder
 */

import { ActionComponentModalContainer as ActionComponent } from 'labstep-web/core/Action/Component';
import { TextPlaceholder } from 'labstep-web/core/Text/Placeholder';
import type { Entity } from 'labstep-web/models/entity.model';
import type React from 'react';
import { startEditingActiveCell } from '../utils';
import type { IDataGridPlaceholderProps } from './types';

export const DataGridPlaceholder: React.FC<
  IDataGridPlaceholderProps<Entity>
> = ({ children, disabled, params, editable, placeholder }) => {
  if (
    !(typeof editable === 'function' ? editable(params) : editable)
  ) {
    return <TextPlaceholder children={placeholder || 'No value'} />;
  }
  return (
    <ActionComponent
      disabled={disabled}
      type="text"
      text={children || 'Enter'}
      icon={undefined}
      elementProps={{
        placeholder: true,
        gridCell: true,
      }}
      onClick={(): void => startEditingActiveCell(params)}
    />
  );
};
